import { PropertyEmailLookupModelDto } from "./../../models/lookup/property.lookup-email.model";
import { MutationTree } from "vuex";
import { CommonObjectModel, IGenericObject } from "../../models/common";
import { ILookupState } from "./lookup-states.store";
import lookupTypesStore from "./lookup-types.store";
import Vue from "vue";
import { IAppointmentStatus } from "../../models/agenda/appointment-status.model";
import { IAppointmentTypeListing } from '../../models/agenda/appointment-type-listing.model';

const mutations: MutationTree<ILookupState> = <MutationTree<ILookupState>>{
	/**
	 * MUTATION: STORE LOOKUP BY KEY
	 */
	[lookupTypesStore.Set.STORED_LOOKUP_OBJECT]: (
		state,
		request: { key: string; data: any }
	) => {
		Vue.set(state.storedlookupObject, request.key, request.data)
	},
	[lookupTypesStore.Set.STORED_LOOKUP_COLOR]: (
		state,
		request: { key: string; data: any }
	) => {
		Vue.set(state.storedlookupColor, request.key, request.data)
	},
	[lookupTypesStore.Set.REMOVE_LOOKUP_OBJECT_BY_KEY]: (
		state,
		key: string
	) => {
		delete (state.storedlookupObject[key])
	},

	[lookupTypesStore.Set.LIST_OF_CITIES]: (
		state,
		listOfCities: CommonObjectModel[]
	) => {
		state.listOfCities = listOfCities;
	},

	[lookupTypesStore.Set.LIST_OF_SITES]: (
		state,
		listOfSites: CommonObjectModel[]
	) => {
		state.listOfSites = listOfSites;
	},

	[lookupTypesStore.Set.LIST_OF_SINCE_DATE]: (
		state,
		listOfSinceDate: CommonObjectModel[]
	) => {
		state.listOfSinceDate = listOfSinceDate;
	},

	[lookupTypesStore.Set.LIST_OF_RELATION_REVERSE_TYPES]: (
		state,
		listOfRelationReverseTypes: CommonObjectModel[]
	) => {
		state.listOfRelationReverseTypes = listOfRelationReverseTypes;
	},
	[lookupTypesStore.Set.LIST_TYPES_OF_PROPERTY]: (
		state: ILookupState,
		listTypesOfProperty: IGenericObject[]
	) => {
		state.listTypesOfProperty = listTypesOfProperty;
	},
	[lookupTypesStore.Set.LIST_OF_PURPOSES]: (
		state: ILookupState,
		listOfPurposes: IGenericObject[]
	) => {
		state.listOfPurposes = listOfPurposes;
	},
	[lookupTypesStore.Set.LIST_OF_GOALS]: (
		state: ILookupState,
		listOfGoals: IGenericObject[]
	) => {
		state.listOfGoals = listOfGoals;
	},
	[lookupTypesStore.Set.LIST_TYPES_OF_DOCUMENT]: (
		state: ILookupState,
		listOfDocumentTypes: IGenericObject[]
	) => {
		state.listOfDocumentTypes = listOfDocumentTypes;
	},
	[lookupTypesStore.Set.LIST_PUBLISH_TYPES_OF_DOCUMENT]: (
		state: ILookupState,
		listOfDocumentPublish: IGenericObject[]
	) => {
		state.listOfDocumentPublish = listOfDocumentPublish;
	},
	[lookupTypesStore.Set.LIST_OF_PICTUREGROUP]: (
		state: ILookupState,
		listOfPictureGroups: IGenericObject[]
	) => {
		state.listOfPictureGroups = listOfPictureGroups;
	},
	[lookupTypesStore.Set.LIST_OF_ROOM_COVERING]: (
		state: ILookupState,
		listOfRoomCovering: IGenericObject[]
	) => {
		state.listOfRoomCovering = listOfRoomCovering;
	},
	[lookupTypesStore.Set.LIST_OF_ROOM_DESCRIPTIONS]: (
		state: ILookupState,
		listOfRoomDescriptions: IGenericObject[]
	) => {
		state.listOfRoomDescriptions = listOfRoomDescriptions;
	},
	[lookupTypesStore.Set.LIST_OF_ROOM_STATES]: (
		state: ILookupState,
		listOfRoomsStates: IGenericObject[]
	) => {
		state.listOfRoomStates = listOfRoomsStates;
	},
	[lookupTypesStore.Set.LIST_OF_ROOM_FLOORS]: (
		state: ILookupState,
		listOfRoomFloors: IGenericObject[]
	) => {
		state.listOfRoomFloors = listOfRoomFloors;
	},
	[lookupTypesStore.Set.LIST_OF_ROOM_KEYWORDS]: (
		state: ILookupState,
		listOfRoomKeywords: IGenericObject[]
	) => {
		state.listOfRoomKeywords = listOfRoomKeywords;
	},
	[lookupTypesStore.Set.LIST_OF_ORIENTATIONS]: (
		state: ILookupState,
		listOfOrientations: IGenericObject[]
	) => {
		state.listOfOrientations = listOfOrientations;
	},
	[lookupTypesStore.Set.LIST_OF_ADMINISTRATION_CO2_EMISSION]: (
		state: ILookupState,
		listOfCO2Emission: IGenericObject[]
	) => {
		state.listOfCO2Emission = listOfCO2Emission;
	},
	[lookupTypesStore.Set.LIST_OF_ADMINISTRATION_INSULATION]: (
		state: ILookupState,
		listOfInsulation: IGenericObject[]
	) => {
		state.listOfInsulation = listOfInsulation;
	},
	[lookupTypesStore.Set.LIST_OF_ADMINISTRATION_EPCLUXEMBOURG]: (
		state: ILookupState,
		listOfEPCLuxembourg: IGenericObject[]
	) => {
		state.listOfEPCLuxembourg = listOfEPCLuxembourg;
	},
	[lookupTypesStore.Set.LIST_OF_ADMINISTRATION_EPCBRUSSELS]: (
		state: ILookupState,
		listOfEPCBrussels: IGenericObject[]
	) => {
		state.listOfEPCBrussels = listOfEPCBrussels;
	},
	[lookupTypesStore.Set.LIST_OF_ADMINISTRATION_EPCFLANDERS]: (
		state: ILookupState,
		list: IGenericObject[]
	) => {
		state.listOfEPCFlanders = list;
	},
	[lookupTypesStore.Set.LIST_OF_ADMINISTRATION_EPCIMMOWEB]: (
		state: ILookupState,
		list: IGenericObject[]
	) => {
		state.listOfEPCImmoWeb = list;
	},
	[lookupTypesStore.Set.LIST_OF_ADMINISTRATION_EPCTYPE]: (
		state: ILookupState,
		list: IGenericObject[]
	) => {
		state.listOfEPCType = list;
	},
	[lookupTypesStore.Set.LIST_OF_ADMINISTRATION_EPCNR]: (
		state: ILookupState,
		list: IGenericObject[]
	) => {
		state.listOfEPCNR = list;
	},
	[lookupTypesStore.Set.LIST_OF_ADMINISTRATION_EPCkNR]: (
		state: ILookupState,
		list: IGenericObject[]
	) => {
		state.listOfEPCkNR = list;
	},
	[lookupTypesStore.Set.LIST_OF_ADMINISTRATION_GROUNDCERTIFICATE]: (
		state: ILookupState,
		listOfGroundCertificate: IGenericObject[]
	) => {
		state.listOfGroundCertificate = listOfGroundCertificate;
	},
	[lookupTypesStore.Set.LIST_OF_ASBESTOS_PLATFORM]: (
		state: ILookupState,
		listOfAsbestosType: IGenericObject[]
	) => {
		state.listOfAsbestosType = listOfAsbestosType;
	},
	[lookupTypesStore.Set.LIST_OF_ADMINISTRATION_OILTANKPLACEMENT]: (
		state: ILookupState,
		listOfOilTankPlacement: IGenericObject[]
	) => {
		state.listOfOilTankPlacement = listOfOilTankPlacement;
	},
	[lookupTypesStore.Set.LIST_OF_ADMINISTRATION_OILTANKFURTHEREXPLOITATION]: (
		state: ILookupState,
		listOfOilTankFurtherExploitation: IGenericObject[]
	) => {
		state.listOfOilTankFurtherExploitation = listOfOilTankFurtherExploitation;
	},
	[lookupTypesStore.Set
		.LIST_OF_ADMINISTRATION_OILTANKCERTIFICATEOFINSPECTION]: (
			state: ILookupState,
			listOfOilTankCertificateOfInspection: IGenericObject[]
		) => {
			state.listOfOilTankCertificateOfInspection = listOfOilTankCertificateOfInspection;
		},
	[lookupTypesStore.Set.LIST_OF_ADMINISTRATION_ELECTRICITYIMMOWEB]: (
		state: ILookupState,
		listOfElectricityImmoWeb: IGenericObject[]
	) => {
		state.listOfElectricityImmoWeb = listOfElectricityImmoWeb;
	},
	[lookupTypesStore.Set.LIST_OF_ADMINISTRATION_GASOLINEIMMOWEB]: (
		state: ILookupState,
		listOfGasolineImmoWeb: IGenericObject[]
	) => {
		state.listOfGasolineImmoWeb = listOfGasolineImmoWeb;
	},

	[lookupTypesStore.Set.LIST_OF_ADMINISTRATION_PERMITOPTIONS]: (
		state: ILookupState,
		listOfPermitOptions: IGenericObject[]
	) => {
		state.listOfPermitOptions = listOfPermitOptions;
	},
	[lookupTypesStore.Set.LIST_OF_ADMINISTRATION_HAS_SUMMON]: (
		state: ILookupState,
		listOfHasSummon: IGenericObject[]
	) => {
		state.listOfHasSummon = listOfHasSummon;
	},
	[lookupTypesStore.Set.LIST_OF_ADMINISTRATION_AREAAPPLICATION]: (
		state: ILookupState,
		listOfAreaApplication: IGenericObject[]
	) => {
		state.listOfAreaApplication = listOfAreaApplication;
	},
	[lookupTypesStore.Set.LIST_OF_ADMINISTRATION_HERITAGETYPE]: (
		state: ILookupState,
		listOfHeritageType: IGenericObject[]
	) => {
		state.listOfHeritageType = listOfHeritageType;
	},
	[lookupTypesStore.Set.LIST_OF_ADMINISTRATION_FLOODRISK]: (
		state: ILookupState,
		listOfFloodRisk: IGenericObject[]
	) => {
		state.listOfFloodRisk = listOfFloodRisk;
	},
	[lookupTypesStore.Set.LIST_OF_ADMINISTRATION_FLOODZONE]: (
		state: ILookupState,
		listOfFloodZoneType: IGenericObject[]
	) => {
		state.listOfFloodZoneType = listOfFloodZoneType;
	},
	[lookupTypesStore.Set.LIST_OF_ADMINISTRATION_YESNO]: (
		state: ILookupState,
		listOfYesNo: IGenericObject[]
	) => {
		state.listOfYesNo = listOfYesNo;
	},
	[lookupTypesStore.Set.LIST_OF_MANWOMAN]: (
		state: ILookupState,
		listOfManWoman: IGenericObject[]
	) => {
		state.listOfManWoman = listOfManWoman;
	},
	[lookupTypesStore.Set.LIST_OF_VIAGERTYPE]: (
		state: ILookupState,
		listOfViagerType: IGenericObject[]
	) => {
		state.listOfViagerType = listOfViagerType;
	},
	[lookupTypesStore.Set.LIST_OF_REGISTERED_TYPE_BRUSSELS]: (
		state: ILookupState,
		listOfRegisteredTypeBrussels: IGenericObject[]
	) => {
		state.listOfRegisteredTypeBrussels = listOfRegisteredTypeBrussels;
	},
	[lookupTypesStore.Set.LIST_OF_REGISTERED_TYPE_WALLONIA]: (
		state: ILookupState,
		listOfRegisteredTypeWallonia: IGenericObject[]
	) => {
		state.listOfRegisteredTypeWallonia = listOfRegisteredTypeWallonia;
	},
	[lookupTypesStore.Set.LIST_OF_REGISTERED_TYPE_FLANDERS]: (
		state: ILookupState,
		listOfRegisteredTypeFlanders: IGenericObject[]
	) => {
		state.listOfRegisteredTypeFlanders = listOfRegisteredTypeFlanders;
	},
	[lookupTypesStore.Set.LIST_OF_REGISTERED_TYPE_NONE]: (
		state: ILookupState,
		listOfRegisteredTypeNone: IGenericObject[]
	) => {
		state.listOfRegisteredTypeNone = listOfRegisteredTypeNone;
	},
	[lookupTypesStore.Set.LIST_OF_CHARGE_ELEMENTS]: (
		state: ILookupState,
		listOfChargeElements: IGenericObject[]
	) => {
		state.listOfChargeElements = listOfChargeElements;
	},
	[lookupTypesStore.Set.LIST_OF_PUBLIC_UTILITIES]: (
		state: ILookupState,
		listOfPublicUtilities: IGenericObject[]
	) => {
		state.listOfPublicUtilities = listOfPublicUtilities;
	},
	[lookupTypesStore.Set.LIST_OF_EMAIL_BY_PROPERTYIDS]: (
		state: ILookupState,
		source: PropertyEmailLookupModelDto[]
	) => {
		state.listOfEmailByPropertyIds = source;
	},
	[lookupTypesStore.Set.LIST_OF_APPOINTMENT_STATUS]: (state, payload: IAppointmentStatus[]) => {
		state.listOfAppointmentStatus = payload
	}

	, [lookupTypesStore.Set.LIST_OF_APPOINTMENT_TYPE]: (state, payload: IAppointmentTypeListing[]) => {
		state.listOfAppointmentTypes = payload
	}
	, [lookupTypesStore.Set.LIST_OF_DURATION_TASKS]: (state, payload) => {
		state.listOfDurationTasks = payload;
	},
	[lookupTypesStore.Set.LIST_OF_PERSONAL_BY_AGENDA_ID]: (state, payload: any[]) => {
		state.listOfPersonalByAgendaId = payload || []
	},
	[lookupTypesStore.Set.LIST_CANDIDATES]: (stage, payload: any[]) => {
		stage.listOfCandidates = payload;
	},
	[lookupTypesStore.Set.LIST_OF_TASK_GROUPS]: (state: ILookupState, payload: any[]) => {
		state.listOfTaskGroups = payload;
	},
};

export default mutations;
